export var MEDIA_QUERIES = {
    PC_TABLET: '@media screen and (min-width: 768px)',
    PHONE: '@media screen and (max-width: 767px)',
    PC: '@media screen and (min-width: 1024px)',
    TABLET: "@media screen and (min-width: 768px) and (max-width: 1023px)",
};
